import { defineCustomElement } from "vue"
import ChartTooltipItem from "./chart-tooltip-item.ce.vue"
import ChartCellPosition from "./chart-cell-position.ce.vue"


customElements.define('chart-tooltip-item', defineCustomElement(ChartTooltipItem))
customElements.define('chart-cell-position', defineCustomElement(ChartCellPosition))
